import { useTotalMonthlyUsageService, useSubnetUsageService } from 'services'

const useReport = () => {
    const { data } = useTotalMonthlyUsageService()
    const { data: subnet_usages } = useSubnetUsageService()

    return {
        monthly_usage: data,
        subnet_usages,
    }
}

export default useReport
